'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var _react = require('react');
// React-19 modernisation (Phase 6): react-sortable-hoc passed its drag Manager
// from SortableContainer to SortableElement/Handle via the LEGACY context API
// (getChildContext / childContextTypes / contextTypes), which React 19 removes.
// This single modern context replaces it. Value = the Manager instance.
var SortableContext = _react.createContext(null);
SortableContext.displayName = 'RSHSortableContext';
exports.default = SortableContext;
